<template>
  <div class="last-page-container h-100 w-100" v-bind:style="backgroundStyle"  >
    <div class="d-flex px-3 pt-5 pb-2">
      <div class="share-area pr-3">
        <div class="d-flex flex-column">
          <img src="/koreyomo/static/assets/images/share.png" height="234"/>
<!--          <a href="javascript:" @click="snsFBURL(shareTextT)">
            <img class="mb-2" src="/koreyomo/static/assets/images/fb_icon.png" width="44" height="44"/>
          </a>-->
          <a :href="snsURL(shareTextT,'マンガほっと')">
            <img src="/koreyomo/static/assets/images/twitter_icon.png" width="44" height="44"/>
          </a>
         
        </div>
      </div>
      <div class="flex-grow-1">
        <div class="work-area mb-3" v-bind:style="borderStyle">
          <div class="container-fluid p-0" v-bind:style="backgroundStyle">
            <div class="row no-gutters">
              <div class="col-12 p-2">
                <img class="img-fluid mb-2" v-bind:src="workThumbnailImage" />
                <p v-bind:style="textStyle" style="font-size:13px;">{{ catchPhrase }}</p>
                <p class="work-title" v-bind:style="textStyle" style="font-size:13px;">{{ workName }}</p>
                <p v-bind:style="textStyle" style="font-size:13px;">{{ authorName }}</p>
              </div>
            </div>
          </div>
        </div>

        <template v-if="nextStoryItem !== null">
          <div class="container-fluid p-0 mb-3" v-bind:style="borderStyle">
            <div class="row no-gutters align-items-center">
              <div class="col-3 p-2">
                <img class="img-fluid" v-bind:src="nextStoryItem.storyBannerImageUrl" />
              </div>
              <div class="col p-1">
                <p v-bind:style="textStyle" style="font-size:11px;">次の話へ</p>
                <p class="next-story-title" v-bind:style="textStyle" style="font-size:11px;">{{ nextStoryItem.storyTitle }}</p>
              </div>
              <div class="p-2">
                <template v-if="nextStoryItem.isWebRead">
                  <router-link v-bind:style="buttonStyle" class="btn btn-read px-4" :to="{ name: 'Viewer', params: { workCode: workCode, storyId: nextStoryId }, query: { rt: restoreToken, timeres: timeRes, pid: pid } }">
                  試し読み
                  </router-link>
                </template>
                <template v-else>
                  <a v-bind:href="getMangahotDetailUrl(workCode, restoreToken, timeRes, pid)" v-bind:style="buttonStyle" class="btn btn-read">作品詳細へ戻る</a>
                </template>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div v-if="recommendItems.length > 0">
      <div class="w-100 px-3 py-1 recommend-label" v-bind:style="[textStyle, darkBackgroundStyle]">
        <p class="">この作品の読了感に近いオススメ作品はコチラ！</p>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row" v-if="recommendItems.length > 0">
        <div class="p-0 col-4" v-for="item in recommendItems">
          <a v-bind:href="getMangahotDetailUrl(item.workCode, restoreToken, personaId, timeRes)"><img v-bind:src="item.bannerMediumImageUrl" class="img-fluid"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import dynamicStyleMixin from "../components/DynamicStyleMixin";

  export default {
    name: "ViewerLastPage",
    mixins: [dynamicStyleMixin],
    data () {
        return {
            personaId:'',
            shareTextT: 'Koreyomo',
            shareTextF: 'Koreyomo',
        }
    },
    props: {
      /** @type {?KoreyomoWorkInfo} */
      workInfo: {
        type: Object,
        default: () => null
      },
      /** @type {?KoreyomoStoryItem} */
      nextStoryItem: {
        type: Object,
        default: () => null
      },
      /** @type {Array.<KoreyomoWorkItem>}*/
      recommendItems: {
        type: Array,
        default: () => []
      },
      restoreToken: {
        type: String,
        default: () => undefined
      },
      timeRes: {
        type: String,
        default: () => undefined
      },
      pid: {
        type: String,
        default: () => undefined
      },
    },
    computed: {
      workCode: function() {
        return this.workInfo ? this.workInfo.workCode : ""
      },
      workName: function() {
        return this.workInfo ? this.workInfo.workName : ""
      },
      catchPhrase: function() {
        return this.workInfo ? this.workInfo.catchPhrase : ""
      },
      authorName: function() {
        return this.workInfo ? this.workInfo.authorName : ""
      },
      workThumbnailImage: function() {
        return this.workInfo ? this.workInfo.bannerLargeImageUrl : null
      },
      nextStoryId: function() {
        return this.nextStoryItem ? this.nextStoryItem.storyId : ""
      },
      // Override DynamicStyleMixin
      styleObject: function () {
        return this.workInfo
      }
    },
    mounted(){
      this.shareTextT = this.$parent.shareTextTwitter
      this.shareTextF = this.$parent.shareTextFB
      this.recommendWorksFromWorksData = this.$parent.recommendWorksFromWorksData
    }
  }
</script>

<style scoped>
  .last-page-container {
    overflow-y: auto;
  }

  .work-title {
    font-size: larger;
    font-weight: bold;
  }

  .next-story-title {
    font-weight: bold;
  }

  .recommend-label {
    font-weight: bold;
  }

  .btn-read {
    font-size: smaller;
    background-color: #ffffff;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ViewerLastPage.vue